<template>
  <header>

    <div class="heder-top">
      <div class="wrapper">
        <div class="logo">
          <img src="@/assets/logo.png" alt="Spectrum logo">
        </div>

        <div class="lg" v-if="0">
          <a :href="langUrl('es')" v-show="$i18n.locale == 'en'">Español</a>
          <a :href="langUrl('en')" v-show="$i18n.locale == 'es'">English</a>
        </div>
      </div>
    </div>

    <div class="header-main">
      <h1>{{ $t('header.l1') }}</h1>
      <p>{{ $t('header.l2') }}</p>
    </div>
    
  </header>
</template>

<script>
export default {
  name: 'HeaderComponent',
  methods:{
    langUrl(lang){
      const urlParams = new URLSearchParams(window.location.search);
      if(lang != 'en'){
        urlParams.set('lang', lang)
      }else{
        urlParams.delete('lang')
      }
      return window.location.pathname + '?' + urlParams.toString()
    }
  }
}
</script>

<style scoped>
header .heder-top {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
}
header .heder-top .wrapper {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}
header .logo {
  width: 1052px;
  text-align: center;
}
header .logo img {
  width: 97.17px;
  margin-top: 5px;
}
header .lg {
  width: 63px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
}
header .lg a {
  color: #000;
  font-size: 16px;
  text-decoration: none;
}
header .header-main {
  background-image: -webkit-gradient(linear, left top, left bottom, color-stop(40%, #0a2148), to(#041426));
  background-image: linear-gradient(to bottom, #0a2148 40%, #041426);
  width: 100%;
  height: 120px;
  text-align: center;
  color: #fff;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-line-pack: center;
      align-content: center;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
}
header .header-main h1 {
  font-family: "Gotham-Bold", sans-serif;
  font-size: 32px;
  width: 100%;
}
header .header-main p {
  font-size: 18px;
}



@media (max-width: 1250px) {
  header .logo img {
    width: 85.03px;
  }
  .wrapper {
    max-width: 100%;
    padding: 0 20px;
  }
}
@media (max-width: 661px) {
  header .header-main {
    background: #F8F8F8;
    color: #000;
    border-top: 2px solid #1858C6;
  }
}
@media (max-width: 600px) {
  header .logo img {
    width: 85.03px;
  }
  header .header-main {
    padding: 10px 20px;
  }
  header .header-main h1 {
    font-size: 27px;
  }
  header .header-main p {
    font-size: 15px;
  }
}
</style>
